import { DatabaseService } from './../database/database.service';
import { CxAlertsService } from './../libs/components/cx-alerts/cx-alerts.service';
import { Router } from '@angular/router';
import { User } from './model/user';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { map, concatMap } from 'rxjs/operators';
import * as bcrypt from 'bcryptjs';
import { properties } from '../../app.properties';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentUser: Observable<User>;
  startToken: Date;
  private currentUserSubject: BehaviorSubject<User>;
  loginFirstTime: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private alertService: CxAlertsService,
    private databaseService: DatabaseService
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      // TODO: aca habría que sacar ya de una vez en algún momento el local storage
      JSON.parse(sessionStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get localCurrentUser(): User {
    // TODO: aca habría que sacar ya de una vez en algún momento el local storage
    const currentUser = this.databaseService.getCurrentUserFromOfflineDB();
    return JSON.parse(sessionStorage.getItem('currentUser'));
  }

  updateCurrentUser(user: any): void {
    this.currentUserSubject.next(user);
    this.loginFirstTime = true;
    console.log('this.loginFirstTime ' + this.loginFirstTime);
  }



  async getCurrentUserFromOffline() {
    const currentUser = await await this.databaseService.getCurrentUserFromOfflineDB();
    return await currentUser;
  }

  clearSessionData(): void {
    const isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
    if (isOnline) {
      localStorage.removeItem('filtroperiodicos');
      localStorage.removeItem('filtroreevaluacion');
      localStorage.removeItem('configPageperiodicos');
      localStorage.removeItem('configPagereevaluacion');
      this.databaseService.cleanTable('examenesPeriodicos');
      this.databaseService.cleanTable('examenesReevaluacion');
    }
    localStorage.removeItem('filtroporEnviar');
    localStorage.removeItem('filtrocargados');
    localStorage.removeItem('configPageporEnviar');
    sessionStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }

  async createDataLocalStorage(user: User): Promise<void> {
    const aaa = this.databaseService.updateCurrentUserOnOfflineDB(user);
    sessionStorage.setItem('currentUser', JSON.stringify(user));
  }

  loginOnline(user: string, pass: string): any {
    return this.authenticateUser(user, pass).pipe(
      concatMap((tokenData) => this.getUserData(user, tokenData.accessToken))
    );
  }

  /* Call services */

  logout(): void {

    this.clearSessionData();
    this.router.navigate(['/login']);
  }

  getUsersOffline(): Observable<any> {
    let userOfflineRequest: any;
    this.currentUser.subscribe((obj) => {
      userOfflineRequest = {
        modelId: obj.modelId,
        modelRole: obj.modelRole,
      };
    });
    return this.http.post<any>(
      environment.apiUrl + "usuarios",
      userOfflineRequest
    );
  }

  loginOffline(plainText: string, userText: string, passText: string): void {

    if (!this.loginFirstTime) {
      this.alertService.openAlertWarn('El usuario y/o contraseña son incorrectos, por favor verifique');
    } else {
      this.compareHash(plainText, userText, passText);
    }
  }

  private saveUserData(data): void {
    const userData = this.localCurrentUser;
    userData.username = data.username;
    userData.isLogged = true;
    userData.modelId = data.modelId;
    userData.userId = data.userId;
    userData.modelRole = data.modelRole;
    userData.modelCode = data.modelCode;
    userData.modelName = data.modelName;
    this.alertService.closeAllAlerts();
    this.createDataLocalStorage(userData);
    this.updateCurrentUser(userData);
  }

  private authenticateUser(user: string, pass: string) {
    const tokenFormData = new FormData();
    tokenFormData.append('grant_type', 'password');
    tokenFormData.append('username', user);
    tokenFormData.append('password', pass);
    const authCredentials = btoa(
      `${properties.apiWebClient}:${properties.apiWebClientPassword}`
    );

    return this.http
      .post<any>(environment.apiUrl + 'oauth/token', tokenFormData, {
        headers: {
          Authorization: `Basic ${authCredentials}`,
        },
        withCredentials: true,
      })
      .pipe(
        map((tokenData) => {
          const userData = new User();
          userData.accessToken = tokenData.access_token;
          userData.refreshToken = tokenData.refresh_token;
          this.createDataLocalStorage( userData );
          localStorage.setItem('expired', 'false')
          return userData;
        })
      );
  }

  private getUserData(user: string, token: string) {
    return this.http
      .post<any>(
        environment.apiUrl + 'userData',
        { username: user },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .pipe(
        map((response) => {
          this.saveUserData(response.response);
        })
      );
  }

  private async compareHash(
    plainText: string,
    userText: string,
    passText: string
  ): Promise<boolean> {
    const users = await this.databaseService.getOfflineUsersFromOfflineDB();
    let match: boolean;
    let matchUser: boolean;
    let matchPass: boolean;
    let user: any;

    if (users.api) {
      for (let i = 0; i < users.usuarios.length; i++) {
        match = await bcrypt.compare(plainText, users.usuarios[i].token);
        if (match) {
          user = users.usuarios[i];
          i = users.usuarios.length;
        }
      }
    } else {
      matchUser = await bcrypt.compare(userText, users.usuarios[0].userToken);
      if (matchUser) {
        matchPass = await bcrypt.compare(passText, users.usuarios[0].passToken);
        if (matchPass) {
          user = users.usuarios[0];
          match = true;
        }
      }
    }

    if (match) {
      this.validateExpirationDateOffline().then((result) => {
        if (result) {
          this.alertService.closeAllAlerts();
          this.alertService.openAlertInfo(
            'Su tiempo de conexión Offline superó el definido por el sistema, por favor conéctese al Internet para ingresar de nuevo'
          );
        }else{
          this.saveUserDataOffline(user).then((res) => {
            this.router.navigate(['examenes']);
          });
        }
      });

    } else {
      if (users.api) {
        this.alertService.openAlertWarn('El usuario y/o contraseña son incorrectos, por favor verifique');
      } else {
        if (matchUser) {
          this.alertService.openAlertWarn('El usuario y/o contraseña son incorrectos, por favor verifique');
        } else {
          this.alertService.openAlertWarn(
            'Su usuario y contraseña no se encuentran sincronizados en el dispositivo, por favor verifique su conexión a Internet'
          );
        }
      }
    }
    return match;
  }

  private async validateExpirationDateOffline(): Promise<boolean> {
    return new Promise((resolve, project) => {
      const usuarioOffline = JSON.parse(localStorage.getItem('offlineUsers'));
      const usuarioDate = usuarioOffline ? usuarioOffline.expirationDate : null;

      if (!usuarioOffline || (!usuarioDate && this.validateIfDateIsOlder(usuarioOffline.expirationDate))) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }

  private validateIfDateIsOlder(date: any): boolean {
    const today = new Date();
    if (today > new Date(date)) {
      return true;
    }
    return false;
  }

  private async saveUserDataOffline(data): Promise<any> {
    console.log(data);
    const currentUser = (await this.getCurrentUserFromOffline()) as any;
    const userData = new User();
    userData.isLogged = true;
    userData.modelId = data.modelId;
    userData.userId = data.userId;
    userData.modelName = data.modelName;
    userData.modelRole = 'OFF';
    userData.accessToken = currentUser.accessToken;
    userData.refreshToken = currentUser.refreshToken;
    this.alertService.closeAllAlerts();
    this.createDataLocalStorage(userData);
    this.updateCurrentUser(userData);
    return currentUser;
  }
}
